import { Footer } from "@nju/feature-portal-footer";
import { HelpPage } from "@nju/feature-portal-help";
import { Header, HeaderBackgroundWrapper } from "@nju/feature-sales-header";
import { BlockContent, LayoutWrapper } from "@nju/ui";

export default function Help() {
  return (
    <LayoutWrapper>
      <HeaderBackgroundWrapper>
        <Header />
      </HeaderBackgroundWrapper>
      <BlockContent spacing="l">
        <HelpPage />
      </BlockContent>
      <Footer />
    </LayoutWrapper>
  );
}
